import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { EstanciaCarousel } from '../components/EstanciaCarousel';
import { TrujilloCarousel } from '../components/TrujilloCarousel';
import { WeddingCarousel } from '../components/WeddingCarousel';
import { FullscreenMenu } from '../components/FullscreenMenu';
import { BookingModal } from '../components/BookingModal';
const WHATSAPP_URL = 'https://wa.me/584246782227?text=Hola%2C%20quiero%20informaci%C3%B3n%20sobre%20disponibilidad%20en%20Hacienda%20El%20Rosario';
// Reusable elegant CTA component
const CtaLink = ({
  className = '',
  onClick
}: {
  className?: string;
  onClick?: () => void;
}) => <button onClick={onClick} className={`inline-block border-b border-current pb-1 font-sans text-xs uppercase tracking-widest transition-opacity hover:opacity-60 bg-transparent cursor-pointer focus:outline-none ${className}`} data-id="element-88">
    Ver disponibilidad
  </button>;
// Reusable fade-in wrapper for scroll animations
const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-80px'
}} transition={{
  duration: 0.8,
  delay,
  ease: [0.21, 0.47, 0.32, 0.98]
}} className={className} data-id="element-89">
    {children}
  </motion.div>;
const AccordionItem = ({
  title,
  content
}: {
  title: string;
  content: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-t border-ink/20 last:border-b" data-id="element-90">
      <button onClick={() => setIsOpen(!isOpen)} className="flex w-full items-center justify-between py-5 md:py-6 text-left focus:outline-none group" data-id="element-91">
        <span className="font-sans text-xs md:text-sm uppercase tracking-[0.2em] text-ink group-hover:opacity-70 transition-opacity" data-id="element-92">
          {title}
        </span>
        <span className="relative flex h-3 w-3 items-center justify-center opacity-60" data-id="element-93">
          <span className={`absolute h-[1px] w-3 bg-ink transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-94" />
          <span className={`absolute h-3 w-[1px] bg-ink transition-transform duration-300 ${isOpen ? 'rotate-90 opacity-0' : ''}`} data-id="element-95" />
        </span>
      </button>
      <motion.div initial={false} animate={{
      height: isOpen ? 'auto' : 0,
      opacity: isOpen ? 1 : 0
    }} transition={{
      duration: 0.3,
      ease: [0.25, 0.1, 0.25, 1]
    }} className="overflow-hidden" data-id="element-96">
        <p className="pb-6 font-light text-ink/75 text-[15px] md:text-[16px] leading-[1.8] font-[Inter,_sans-serif]" data-id="element-97">
          {content}
        </p>
      </motion.div>
    </div>;
};
const experienciaImages = ['https://cdn.magicpatterns.com/uploads/p85nZE9pSVZinuP2G3jX2c/IMG_1149.jpg', 'https://cdn.magicpatterns.com/uploads/mzm1b99fD4W2PeHF6tQf86/IMG_2191.jpg', 'https://cdn.magicpatterns.com/uploads/ehhJfwLYxrEXs2QzJyM7rQ/IMG_4513.jpg'];
function ExperienciaCarousel() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % experienciaImages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);
  return <div className="relative w-full h-[40vh] md:h-[60vh]" data-id="element-98">
      {experienciaImages.map((src, idx) => <motion.img key={src} src={src} alt={`Interior de Hacienda El Rosario ${idx + 1}`} className="absolute inset-0 w-full h-full object-cover" initial={false} animate={{
      opacity: idx === current ? 1 : 0
    }} transition={{
      duration: 1.2,
      ease: [0.25, 0.1, 0.25, 1]
    }} data-id="element-99" />)}
    </div>;
}
export function Landing() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [bookingOpen, setBookingOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > window.innerHeight * 0.85);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <main className="min-h-screen w-full bg-cream font-sans text-ink selection:bg-cream-dark" data-id="element-100">
      {/* Fullscreen Menu */}
      <FullscreenMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} data-id="element-101" />

      {/* Booking Modal */}
      <BookingModal isOpen={bookingOpen} onClose={() => setBookingOpen(false)} data-id="element-102" />

      {/* Sticky Header */}
      <header className={`fixed top-0 left-0 z-50 flex w-full items-center justify-between px-6 py-5 md:px-16 lg:px-24 transition-all duration-500 ease-in-out ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-[0_1px_0_rgba(0,0,0,0.08)]' : 'bg-transparent'}`} data-id="element-103">
        <button onClick={() => setMenuOpen(true)} aria-label="Menu" className={`font-sans text-xl leading-none transition-all duration-500 hover:opacity-60 focus:outline-none ${scrolled ? 'text-[#2C2420]' : 'text-white'}`} data-id="element-104">
          ☰
        </button>
        <div className="absolute left-1/2 -translate-x-1/2 flex items-center gap-3" data-id="element-105">
          <img src="https://cdn.magicpatterns.com/uploads/1NCxQgBpXqFs8eMFMVuBhB/IMG_4868.png" alt="Hacienda El Rosario logo" className={`h-8 w-auto transition-all duration-500 mix-blend-multiply ${scrolled ? 'opacity-100 scale-100' : 'opacity-0 scale-90 pointer-events-none'}`} data-id="element-106" />
          <span className={`font-serif text-xs tracking-[0.25em] uppercase hidden md:block transition-all duration-500 ${scrolled ? 'text-[#2C2420]' : 'text-white'}`} data-id="element-107">
            Hacienda El Rosario
          </span>
        </div>
        <button onClick={() => setBookingOpen(true)} className={`font-sans text-xs uppercase tracking-[0.2em] transition-all duration-500 hover:opacity-60 hover:underline hover:underline-offset-4 hover:decoration-[0.5px] bg-transparent cursor-pointer focus:outline-none ${scrolled ? 'text-[#2C2420]' : 'text-white'}`} data-id="element-108">
          Reservar
        </button>
      </header>

      {/* Floating WhatsApp Button */}
      <motion.a href="https://wa.me/584246782227" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg hover:shadow-xl transition-shadow" animate={{
      scale: [1, 1.05, 1]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} aria-label="Contact via WhatsApp" data-id="element-109">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-110">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" fill="white" data-id="element-111" />
        </svg>
      </motion.a>

      {/* 1. HERO */}
      <section id="inicio" className="relative h-[100svh] w-full overflow-hidden" data-id="element-112">
        <img src="https://cdn.magicpatterns.com/uploads/bAU98bj4avifBLEqAkVX9Q/IMG_3022.jpg" alt="Hacienda El Rosario" className="absolute inset-0 h-full w-full object-cover" data-id="element-113" />
        {/* Subtle gradient just for text readability at the bottom */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent" data-id="element-114" />

        <div className="absolute bottom-0 left-0 flex w-full flex-col px-6 pb-16 md:px-16 md:pb-24 lg:px-24 lg:pb-32" data-id="element-115">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="max-w-2xl text-white pt-[0px] pb-[0px] mt-[10px] mb-[10px]" data-id="element-116">
            <h1 className="mb-6 font-serif font-light md:text-7xl lg:text-8xl text-[#F2E5E5] pt-[10px] pb-[10px] text-[40px]" data-id="element-117">
              Hacienda El Rosario
            </h1>
            <p className="mb-12 max-w-md font-sans text-sm font-light leading-relaxed text-white/90 md:text-base" data-id="element-118">
              Una casa en la montaña pensada para desconectar de verdad.
            </p>
            <CtaLink className="text-white hover:text-white/80" onClick={() => setBookingOpen(true)} data-id="element-119" />
          </motion.div>
        </div>
      </section>

      {/* 2. CONTEXTO */}
      <section id="la-estancia" className="px-6 pt-12 pb-10 md:px-16 md:pt-20 md:pb-16 lg:px-24" data-id="element-120">
        <FadeIn className="mx-auto max-w-3xl text-center" data-id="element-121">
          <p className="mb-6 uppercase tracking-[0.25em] text-ink-light text-[16px] font-[Merriweather,_serif]" data-id="element-122">
            La Puerta, Trujillo
          </p>
          <p className="italic md:text-4xl md:leading-relaxed text-[18px] font-[300] font-[Inter,_sans-serif]" data-id="element-123">
            "Hacienda El Rosario es una casa de finales de 1800, adaptada para
            recibir pocas familias a la vez, manteniendo la tranquilidad, la
            privacidad y la esencia del lugar."
          </p>

          {/* CTA */}
          <div className="mt-10 flex flex-col items-center gap-4" data-id="element-124">
            <button onClick={() => setBookingOpen(true)} className="group relative font-sans text-xs uppercase tracking-[0.3em] text-ink/80 transition-opacity duration-300 hover:opacity-60 pb-2 bg-transparent cursor-pointer focus:outline-none" data-id="element-125">
              Reserva tu estancia
              <motion.span className="absolute bottom-0 left-1/2 h-[0.5px] bg-ink/40" initial={{
              width: 0
            }} whileInView={{
              width: '120%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.9,
              delay: 0.5,
              ease: [0.21, 0.47, 0.32, 0.98]
            }} style={{
              x: '-50%'
            }} data-id="element-126" />
            </button>
            <p className="font-sans text-[11px] tracking-wide text-[#1E1C16]" data-id="element-127">
              Por favor, toma en cuenta que no aceptamos mascotas
            </p>
          </div>
        </FadeIn>

        {/* Carousel right below CTA */}
        <FadeIn delay={0.2} className="w-full mt-6" data-id="element-128">
          <EstanciaCarousel data-id="element-129" />
        </FadeIn>

        {/* CTA Button after carousel */}
        <FadeIn delay={0.3} className="flex justify-center mt-10" data-id="element-130">
          <button onClick={() => setBookingOpen(true)} className="inline-block border border-[#2C2420]/80 px-12 py-5 font-sans text-xs uppercase tracking-[0.3em] text-[#2C2420]/80 transition-all duration-300 hover:bg-[#2C2420] hover:text-[#FAF8F5] bg-transparent cursor-pointer focus:outline-none" data-id="element-131">
            Verificar disponibilidad
          </button>
        </FadeIn>
      </section>

      {/* 2.5 LA ESTANCIA */}
      <section id="la-experiencia" className="pt-8 pb-10 md:pt-16 md:pb-20" data-id="element-132">
        <div className="px-6 md:px-16 lg:px-24 mx-auto max-w-4xl text-center" data-id="element-133">
          <FadeIn data-id="element-134">
            <p className="mb-6 font-sans uppercase tracking-[0.25em] text-ink-light text-[12px] relative inline-block pb-2 underline underline-offset-4 decoration-ink-light/40 decoration-[0.5px]" data-id="element-135">
              La Experiencia
            </p>
            <p className="font-light text-ink/80 md:text-3xl md:leading-relaxed mx-auto max-w-2xl text-[18px] font-[Inter,_sans-serif]" data-id="element-136">
              Espacios amplios, pensados con equilibrio y sin exceso. La casa
              conserva una colección de antigüedades y piezas de arte que
              acompañan cada espacio, aportando una sensación de historia viva y
              autenticidad. Más que una estadía, es una pausa. Un ritmo que
              baja, conversaciones que se alargan y un entorno que se vuelve
              parte esencial de la experiencia.
            </p>
          </FadeIn>
        </div>

        {/* Image below La Experiencia */}
        <FadeIn delay={0.2} className="w-full mt-10 md:mt-16 px-6 md:px-16 lg:px-24" data-id="element-137">
          <div className="w-full overflow-hidden rounded border-[5px] border-white/90 shadow-[0_2px_20px_rgba(0,0,0,0.06)]" data-id="element-138">
            <ExperienciaCarousel data-id="element-139" />
          </div>
        </FadeIn>

        {/* CTA Button after experiencia carousel */}
        <FadeIn delay={0.3} className="flex justify-center mt-10 px-6 md:px-16 lg:px-24" data-id="element-140">
          <button onClick={() => setBookingOpen(true)} className="inline-block border border-[#2C2420]/80 px-12 py-5 font-sans text-xs uppercase tracking-[0.3em] text-[#2C2420]/80 transition-all duration-300 hover:bg-[#2C2420] hover:text-[#FAF8F5] bg-transparent cursor-pointer focus:outline-none" data-id="element-141">
            Verificar disponibilidad
          </button>
        </FadeIn>
      </section>

      {/* La mesa & El bienestar — unified experience block */}
      <section id="la-mesa" className="py-10 md:py-16" data-id="element-142">
        <FadeIn data-id="element-143">
          <div className="mx-auto max-w-2xl px-6 md:px-16 lg:px-24" data-id="element-144">
            <div className="bg-[#F5F1EB]/60 rounded-sm px-8 py-14 md:px-16 md:py-20 text-center" data-id="element-145">
              {/* La mesa */}
              <p className="font-sans uppercase tracking-[0.35em] text-ink-light text-[11px] md:text-[12px] mb-5" data-id="element-146">
                La mesa
              </p>
              <p className="font-light text-ink/75 text-[16px] md:text-[19px] leading-[1.8] md:leading-[1.85] mx-auto max-w-lg font-[Inter,_sans-serif]" data-id="element-147">
                Un ritmo sin horarios, donde cada encuentro sucede con
                naturalidad. Desayuno incluido. Almuerzos y cenas bajo
                solicitud.
              </p>

              {/* Subtle divider */}
              <div className="my-10 md:my-12 flex justify-center" data-id="element-148">
                <span className="block w-12 h-[0.5px] bg-[#2C2420]/15" data-id="element-149"></span>
              </div>

              {/* El bienestar */}
              <p className="font-sans uppercase tracking-[0.35em] text-ink-light text-[11px] md:text-[12px] mb-5" data-id="element-150">
                El bienestar
              </p>
              <p className="font-light text-ink/75 text-[16px] md:text-[19px] leading-[1.8] md:leading-[1.85] mx-auto max-w-lg font-[Inter,_sans-serif]" data-id="element-151">
                Una extensión natural de la experiencia. El spa se ofrece bajo
                solicitud, para quienes desean llevar la calma del entorno a un
                nivel más profundo.
              </p>
            </div>
          </div>
        </FadeIn>
      </section>

      {/* Explora Trujillo */}
      <section id="explora-trujillo" className="py-10 md:py-16" data-id="element-152">
        <div className="px-6 md:px-16 lg:px-24 mx-auto max-w-4xl text-center" data-id="element-153">
          <FadeIn data-id="element-154">
            <p className="mb-8 md:mb-10 font-sans uppercase tracking-[0.35em] text-ink-light md:text-[12px] relative inline-block pb-2 underline underline-offset-4 decoration-ink-light/40 decoration-[0.5px] text-[14px]" data-id="element-155">
              Explora Trujillo
            </p>
          </FadeIn>
          <FadeIn delay={0.15} data-id="element-156">
            <TrujilloCarousel data-id="element-157" />
          </FadeIn>
        </div>
      </section>

      {/* Eventos en El Rosario */}
      <section id="eventos" className="py-10 md:py-16" data-id="element-158">
        <div className="px-6 md:px-16 lg:px-24 mx-auto max-w-3xl text-center" data-id="element-159">
          <FadeIn data-id="element-160">
            <p className="mb-8 md:mb-10 font-sans uppercase tracking-[0.35em] text-ink-light md:text-[12px] relative inline-block pb-2 underline underline-offset-4 decoration-ink-light/40 decoration-[0.5px] text-[14px]" data-id="element-161">
              Eventos en El Rosario
            </p>
          </FadeIn>
          <FadeIn delay={0.15} data-id="element-162">
            <p className="font-light text-ink/80 md:text-[19px] md:leading-[1.9] mx-auto max-w-2xl font-[Inter,_sans-serif] text-[16px]" data-id="element-163">
              Un espacio donde cada celebración se integra de forma natural con
              el entorno.
            </p>
            <p className="mt-6 font-light text-ink/80 md:text-[19px] leading-[1.85] md:leading-[1.9] mx-auto max-w-2xl font-[Inter,_sans-serif] text-[16px]" data-id="element-164">
              La casa, sus jardines y cada rincón han sido pensados para recibir
              encuentros íntimos, donde la privacidad, la calma y la
              autenticidad definen la experiencia.
            </p>
            <p className="mt-6 font-light text-ink/80 md:text-[19px] leading-[1.85] md:leading-[1.9] mx-auto max-w-2xl font-[Inter,_sans-serif] text-[16px]" data-id="element-165">
              Cada evento se vive de manera única, respetando el ritmo del lugar
              y la esencia de quienes lo habitan.
            </p>
          </FadeIn>
        </div>

        {/* Wedding Carousel */}
        <FadeIn delay={0.3} className="w-full mt-10 md:mt-16 px-6 md:px-16 lg:px-24" data-id="element-166">
          <WeddingCarousel data-id="element-167" />
        </FadeIn>
      </section>

      {/* Nuestra iniciativa local */}
      <section id="nuestra-iniciativa" className="py-10 md:py-16" data-id="element-168">
        <div className="px-6 md:px-16 lg:px-24 mx-auto max-w-3xl text-center" data-id="element-169">
          <FadeIn data-id="element-170">
            <p className="mb-8 md:mb-10 font-sans uppercase tracking-[0.35em] text-ink-light md:text-[12px] relative inline-block pb-2 underline underline-offset-4 decoration-ink-light/40 decoration-[0.5px] text-[14px]" data-id="element-171">
              Nuestra iniciativa local
            </p>
          </FadeIn>
          <FadeIn delay={0.15} data-id="element-172">
            <p className="font-light text-ink/80 md:text-[19px] md:leading-[1.9] mx-auto max-w-2xl font-[Inter,_sans-serif] text-[16px]" data-id="element-173">
              Creemos en honrar el entorno que nos rodea y a quienes forman
              parte de él. Cada acción dentro de la hacienda nace desde el
              respeto por la tierra, el ritmo natural y la comunidad que la
              habita.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="mt-12 md:mt-16 text-left mx-auto max-w-2xl" data-id="element-174">
            <AccordionItem title="Cultivo de café" content="Un proceso que comienza en la tierra y se transforma en experiencia. El café que servimos forma parte del mismo entorno que nos rodea, cultivado con dedicación y respeto por su origen." data-id="element-175" />
            <AccordionItem title="Producción de miel" content="La miel nace como resultado del equilibrio entre naturaleza y cuidado. Un proceso artesanal que refleja la riqueza del paisaje y su biodiversidad." data-id="element-176" />
            <AccordionItem title="Sembradíos de hortalizas" content="Los alimentos parten de lo esencial: la tierra. Nuestros sembradíos forman parte de una práctica consciente, donde lo natural marca el ritmo de cada preparación." data-id="element-177" />
          </FadeIn>
        </div>
      </section>

      {/* Otra experiencia */}
      <section className="py-10 md:py-16" data-id="element-178">
        <div className="px-6 md:px-16 lg:px-24 mx-auto max-w-3xl text-center" data-id="element-179">
          <FadeIn data-id="element-180">
            <p className="mb-8 md:mb-10 font-sans uppercase tracking-[0.35em] text-ink-light md:text-[12px] relative inline-block pb-2 underline underline-offset-4 decoration-ink-light/40 decoration-[0.5px] text-[14px]" data-id="element-181">
              Otra experiencia
            </p>
          </FadeIn>
          <FadeIn delay={0.15} data-id="element-182">
            <p className="md:text-[22px] md:leading-[1.6] mx-auto max-w-xl font-[Inter,_sans-serif] mb-2 text-[20px] text-[#070707] font-[400]" data-id="element-183">
              Estancia San Miguel Spa
            </p>
            <p className="md:text-[17px] md:leading-[1.85] mx-auto max-w-lg font-[Inter,_sans-serif] text-[15px] font-[200] text-[#2C2420]" data-id="element-184">
              De los mismos anfitriones. Una experiencia pensada para parejas,
              donde la tranquilidad, la privacidad y el ritmo pausado toman un
              lugar central
            </p>
          </FadeIn>
          <FadeIn delay={0.3} className="mt-10 md:mt-14" data-id="element-185">
            <a href="#" className="block group" data-id="element-186">
              <div className="w-full overflow-hidden rounded border-[5px] border-white/90 shadow-[0_2px_20px_rgba(0,0,0,0.06)]" data-id="element-187">
                <img src="https://cdn.magicpatterns.com/uploads/4UPPPBQGcKcpwdAQrrWUNV/photo_2026-02-18_12-19-36.jpg" alt="Estancia San Miguel Spa" className="w-full h-[35vh] md:h-[50vh] object-cover transition-transform duration-700 ease-out group-hover:scale-[1.02]" data-id="element-188" />
              </div>
            </a>
          </FadeIn>
        </div>
      </section>

      {/* CONTACTO SECTION */}
      <section id="contacto" className="bg-white" data-id="element-189">
        <div className="py-[140px] pl-10 pr-6 md:pl-16 lg:pl-24 bg-[#FAF8F6]" data-id="element-190">
          <FadeIn className="max-w-[500px]" data-id="element-191">
            {/* Title */}
            <p className="font-sans uppercase tracking-[0.35em] text-[11px] mb-10 text-[#000000]" data-id="element-192">
              Contacto
            </p>

            {/* Phone — protagonist */}
            <p className="font-[Inter,_sans-serif] font-[200] md:text-[40px] lg:text-[48px] tracking-[0.04em] mb-10 text-[20px] text-[#080808]" data-id="element-193">
              +58 424 6782227
            </p>

            {/* Info block — grouped */}
            <div className="mb-8" data-id="element-194">
              <p className="font-[Inter,_sans-serif] font-light text-[14px] md:text-[15px] tracking-[0.02em] leading-[2] text-[#080808]" data-id="element-195">
                elrosariohacienda@gmail.com
              </p>
              <p className="font-[Inter,_sans-serif] font-light text-[14px] md:text-[15px] tracking-[0.02em] leading-[2] text-[#070707]" data-id="element-196">
                La Puerta, Edo. Trujillo , Venezuela
              </p>
            </div>

            {/* Instagram */}
            <a href="https://instagram.com/elrosariohotel" target="_blank" rel="noopener noreferrer" className="inline-block mt-[30px] font-[Inter,_sans-serif] font-light text-[14px] tracking-[0.02em] transition-all duration-300 hover:text-[#2C2420] hover:underline hover:underline-offset-4 hover:decoration-[0.5px] text-[#030303]" data-id="element-197">
              @elrosariohotel
            </a>

            {/* Editorial detail */}
            <p className="mt-[60px] font-[Inter,_sans-serif] font-light text-[11px] tracking-[0.12em] uppercase text-[#060606]" data-id="element-198">
              Hacienda El Rosario · La Puerta, Trujillo
            </p>
          </FadeIn>
        </div>
      </section>

      {/* 9. FOOTER */}
      <footer className="px-6 py-12 md:px-16 lg:px-24" data-id="element-199"></footer>
    </main>;
}